export const EXPAND_DOCUMENT_LEGAL_INFO_BY_COUNTRY = {
    LEGAL_INFO: {
        GDPR: {
            'documentation-gdprLegalIndex': ['a', 'b', 'c', 'd'],
            'documentation-gdprLegalInfo': ['a', 'b'],
        },
        INFO: {
            'documentation-precontractualInformation': ['c'],
            'documentation-legalMiFID': ['5', 'd', '4'],
        },
    },
    LEGAL_INFO_BY_COUNTRY: {
        GDPR: {
            'documentation-gdprLegalIndex': ['a', 'b', 'c', 'd', 'e'],
            'documentation-gdprLegalInfo': ['a', 'b'],
            'documentation-precontractualInformation': ['c'],
        },
        INFO: {
            'documentation-legalInfo2': ['4', 'd', '4'],
            'documentation-legalMiFID': ['5', 'e', '5'],
        },
    },
};
